<template>
  <div>
    <!-- 查询条件 -->
    <b-row ref="queryFormWrapper" >
      <b-col cols="12">
        <b-form inline>
          <b-form-select
            style="min-width:200px;"
            class="m-1"
            :options="orgList"
            v-model="queryParam.criteria.orgId"
            placeholder="请选择机构"
          ></b-form-select>
          <b-form-input
            style="min-width:150px;"
            class="m-1"
            placeholder="联系人"
            v-model="queryParam.criteria.keywords"
          ></b-form-input>

          <b-button variant="outline-primary" @click="handleQuery" class="m-1">查询</b-button>
    <b-dropdown class="mx-1" right text="menu">
      <b-dropdown-item>Item 1</b-dropdown-item>
      <b-dropdown-item>Item 2</b-dropdown-item>
      <b-dropdown-item>Item 3</b-dropdown-item>
    </b-dropdown>


        </b-form>
      </b-col>
    </b-row>

    <!-- 列表 -->
    <div style="min-height:430px;" class="mt-2">
      <b-table
        id="data-table"
        responsive
        hover
        :fields="fields"
        :items="items.data"
        :busy="tableLoading"
        :show-empty="true"
        primary-key="ID"
        empty-text="暂无数据"
        :no-local-sorting="true"
      >
        <template v-slot:table-busy>
          <div class="my-2 d-flex justify-content-center">
            <b-spinner variant="primary" label="Loading..."></b-spinner>
          </div>
        </template>

        <template v-slot:cell(paymentType)="data">
          <b-badge variant="success" v-if="data.value=='0'">转账</b-badge>
          <b-badge variant="info" v-if="data.value=='1'">线上支付</b-badge>
        </template>

        <template v-slot:cell(contactName)="data">
          {{data.item.contactName}}({{data.item.contactTel}})
        </template>

        <template v-slot:cell(applyStatus)="data">
          <b-badge variant="secondary" v-if="data.value=='0'">待处理</b-badge>
          <b-badge variant="success" v-if="data.value=='1'">成功</b-badge>
          <b-badge variant="danger" v-if="data.value=='2'">失败</b-badge>
        </template>


        <template v-slot:cell(actions)="row">
          <b-link @click="handleView(row.item.id)" class="mr-2">查看</b-link>
          <b-link @click="openAuditDialog(row.item.id, true)" v-if="row.item.applyStatus=='0'" class="mr-2">充值</b-link>
          <b-link @click="openAuditDialog(row.item.id, false)" v-if="row.item.applyStatus=='0'" class="mr-2">拒绝</b-link>
        </template>
      </b-table>
    </div>

    <!-- 分页 -->
    <div ref="paginationWrapper" class="mt-3">
      <div class="text-right float-left mx-2" style="height:30px;line-height:30px;"></div>
      <b-pagination
        class="float-right"
        @change="list"
        v-model="queryParam.page"
        :per-page="queryParam.size"
        :total-rows="items.totalElements"
        aria-controls="data-table"
        align="right"
      ></b-pagination>
      <div
        class="text-right float-right mx-2"
        style="height:30px;line-height:30px;"
      >共&nbsp;{{items.totalElements}}&nbsp;条</div>
    </div>

    <loading :show="pageLoading"></loading>
    
    <!-- 转账对话框 -->
    <b-modal
      id="auditModal"
      title="输入审核原因"
      incline
      v-model="auditDialogVisible"
      @ok="handleAudit"
    >
      <template slot="modal-ok">{{buttonName}}</template>
      <template slot="modal-cancel">取消</template>

      <form>
        <validation-observer ref="auditForm">
          <validation-provider
              :rules="{required:true}"
              name="理由"
              v-slot="validationContext"
              >
            <b-form-group label="理由" :invalid-feedback="validationContext.errors[0]">
              <b-form-textarea 
                v-model="reason" 
                :state="validateState(validationContext)"
                rows="4"
                placeholder="请输入通过或者拒绝的理由">
              </b-form-textarea>
            </b-form-group>
          </validation-provider>

        </validation-observer>
      </form>
    </b-modal>    
  </div>
</template>

<script>
import * as rechargeFacade from "../../../api/recharge-facade.js";
import * as orgFacade from "../../../api/org-facade.js";

export default {
  // validations:
  props:{
    orgId: String,
  },
  data() {
    return {
      fields: [
        {
          key: "orgName",
          label: "机构"
        },
        {
          key: "paymentType",
          label: "付款方式"
        },
        {
          key: "amount",
          label: "付款金额"
        },
        {
          key: "contactName",
          label: "联系方式"
        },
        {
          key: "applyStatus",
          label: "处理状态"
        },
        {
          key: "createTime",
          label: "提交时间"
        },
        {
          key: "actions",
          label: "操作",
          thClass: "actions"
        }
      ],

      // 以下为数据展示和传输对象，基本上与后台接口的传输对象一致
      items: {
        totalElements: 0,
        data: []
      },
      queryParam: {
        size: 10,
        page: 1,
        criteria: {
          orgId: "",
          keywords: "",
        },
        sortOrder: { createTime: "descending" }
      },
      pageLoading: false,
      tableLoading: false, // 表格Loading状态

      reason: "",
      auditDialogVisible: false,
      id: "",
      pass: false,
      buttonName:"",
      orgList:{}
    }
  },

  created() {
    this.getOrgInfo();

  },
  mounted() {
    // 异步加载列表数据

    this.handleQuery();

  },
  methods: {
    validateState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
    // 异步加载列表数据
    list(page) {
      if (page) {
        this.queryParam.page = page;
      }
      this.tableLoading = true; // 打开表格的Loading状态
      rechargeFacade
        .pageList(this.queryParam) // 异步调用后台接口
        .then(res => {
          this.items = res; // 为表格填充数据
          this.tableLoading = false; // 关闭表格的Loading状态
        })
        .catch(err => {
          console.log("err", err);
          this.tableLoading = false;
        });
    },

    handleQuery(){
      this.list()
    },

    // 打开对话框
    openAuditDialog(id, pass){
      this.buttonName = pass ? "充值":"拒绝"
      this.auditDialogVisible = true;
      this.id = id;
      this.pass = pass;
      this.reason = "";
    },

    handleAudit(e){
      e.preventDefault();

      this.$refs.auditForm.validate().then(success => {
        if (!success) {
          return;
        }

        var data = new FormData();
        data.append("id",this.id);
        data.append("pass", this.pass);
        data.append("reason",this.reason);

        rechargeFacade
          .audit(data) // 异步调用后台接口
          .then(() => {
            this.$message({
              message: "审核成功，成功充值。",
              type: "success"
            });
            this.list();
            this.auditDialogVisible=false;
            this.tableLoading = false; // 关闭表格的Loading状态
          })
          .catch(err => {
            console.log("err", err);
            this.tableLoading = false;
          });
      })
    },

    //获取机构信息
    async getOrgInfo() {
      this.pageLoading = true;
      orgFacade
        .findByUserRole()
        .then(res => {
          this.pageLoading = false;
          let orgList = [{ text: "机构", value: "" }];

          res.map(item => {
            let org = {};
            org.text = item.name;
            org.value = item.id;
            orgList.push(org);
          });
          this.orgList = orgList;
        })
        .catch(err => {
          console.log("err", err);
          this.pageLoading = false;
        });
    },
    
    // 查看图片
    handleView(id) {
      let fileUrl = process.env.VUE_APP_RECHARGE_DOWNLOAD_PREFIX + id;
      let viewerUrl = "./#/imageViewer?file=";
      window.open(viewerUrl + encodeURIComponent(fileUrl));
    },

  }
};
</script>

<style >
</style>
